/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Position_EstimatedInputs */

const fr_marker_position_estimated = /** @type {(inputs: Marker_Position_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position estimée`)
};

const en_marker_position_estimated = /** @type {(inputs: Marker_Position_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated position`)
};

/**
* | output |
* | --- |
* | "Estimated position" |
*
* @param {Marker_Position_EstimatedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_position_estimated = /** @type {((inputs?: Marker_Position_EstimatedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Position_EstimatedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_position_estimated(inputs)
	return en_marker_position_estimated(inputs)
});